namespace Areas.ITTask {
    "use strict";

    var tabItems = Areas.createTabsWithSameController("ITTask", ["Kanban", "Active", "Completed", "Deleted","Template"], "List");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

    export function cardMoved(e: any) {
        if (e.toComponent === e.fromComponent) {
            return;
        }

        const cardData = e.itemElement.find(".card-data");
        if (cardData) {
            const id = cardData[0].dataset.id;
            const status = e.toComponent.option("Status");
            const url = `/ITTask/Edit/Put/${id}`;
            const data = { statusLk: status };

            Areas.sendRequest(url, JSON.stringify(data), "PUT");
        }
    }

    export function copyRecord() {

        var dataGrid = $('#ITTaskGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/ITTask/List/CopyRecord/" + dataId.toString() + "";
            sendRequest(linkInfo, "", "PUT");
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function copyRecordFromForm() {

        var keyId: any = $('#ITTaskForm').dxForm('instance').option('KeyId');
        if (keyId != null) {
            var linkInfo = "/ITTask/List/CopyRecord/" + keyId.toString() + "";
            sendRequest(linkInfo, "", "PUT");
        }
        else {
            DevExpress.ui.notify("KeyId Missing Contact IT Staff!", "warning", 2000);
        }
    }

    export function moveToNextStatus() {

        var dataGrid = $('#ITTaskGrid').dxDataGrid('instance');
        var dataIds = dataGrid.getSelectedRowKeys();

        if (dataIds.length === 0) {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
        else {
            
            const url = `/ITTask/List/MoveStatus/${dataIds}`;

            sendRequest(url, "", "PUT", () => Areas.refreshGrid('ITTaskGrid'));


        }

    }

    export function moveToNextStatusFromForm() {

        const form = $("#ITTaskForm").dxForm("instance");
        var keyId: any = form.option('KeyId');
        if (keyId != null) {
            var linkInfo = "/ITTask/List/MoveStatus/" + keyId.toString() + "";
            sendRequest(linkInfo, "", "PUT", () => Areas.reloadPage());
        }
        else {
            DevExpress.ui.notify("KeyId Missing Contact IT Staff!", "warning", 2000);
        }

        }

    export function requestByLookupTemplate(itemData: any, itemIndex: any, itemElement: any) {
            itemElement.append(
                `<div><span class="collookupspan">${itemData.displayName}</span>${itemData.email}</div>`);
    }

    export function onRequestByChanged(e: any) {

        let rUserId = e.selectedItem.userId;
        let rEmail = e.selectedItem.email;
        let displayName = e.selectedItem.displayName;
        const form = $("#ITTaskForm").dxForm("instance");
        const newData: any = form.option("formData");

        newData.UserId = rUserId;
        newData.RequestorEmail = rEmail;
        newData.RequestBy = displayName;

        form.option("formData", newData);
    }
}